import { getToken } from "../../helpers/get-token";
import axiosInstance from "../../axios/instance";

async function editInventoryCampaign(id, values) {
    try {
        const token = getToken();
        axiosInstance.defaults.headers.common['authorization'] = token;
        const response = await axiosInstance.put(process.env.REACT_APP_HUB_URL + '/api/inventory-campaigns/' + id, values)
        return response?.data;
    } catch (error) {
        console.log(error);
    }
}

export default editInventoryCampaign;
